import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../lib/api";
import { Loading, Empty } from "../../components/Loading";
import { fmtDateTime } from "../../lib/dates";
import { ArrowLeft, ClipboardList } from "lucide-react";

export default function AuditLog() {
  const navigate = useNavigate();
  const [logs, setLogs] = useState(null);

  useEffect(() => {
    api.get("/audit").then((r) => setLogs(r.data)).catch(() => setLogs([]));
  }, []);

  return (
    <div className="min-h-screen bg-[#FAF8F5] max-w-lg lg:max-w-3xl mx-auto">
      <header className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-slate-200 px-4 py-3 flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="p-2 -ml-2 rounded-xl hover:bg-slate-100"><ArrowLeft className="h-5 w-5" /></button>
        <h1 className="font-display text-lg font-bold">Audit Log</h1>
      </header>
      <div className="px-4 py-4">
        {logs === null ? <Loading /> : logs.length === 0 ? <Empty icon={ClipboardList} text="No audit records yet." /> : (
          <div className="space-y-2">
            {logs.map((l) => (
              <div key={l.id} className="bg-white rounded-xl border border-slate-200 p-4" data-testid="audit-log-item">
                <div className="flex justify-between items-start">
                  <span className="font-bold text-slate-800 text-sm">{l.action}</span>
                  <span className="text-xs text-slate-400">{fmtDateTime(l.created_at)}</span>
                </div>
                <p className="text-xs text-slate-500 mt-1">By {l.user_name}</p>
                {(l.old_value || l.new_value) && (
                  <p className="text-xs text-slate-600 mt-1">
                    {l.old_value ? <span className="text-red-500 line-through">{l.old_value}</span> : null}
                    {l.old_value && l.new_value ? " → " : ""}
                    {l.new_value ? <span className="text-emerald-600 font-semibold">{typeof l.new_value === "object" ? JSON.stringify(l.new_value) : l.new_value}</span> : null}
                  </p>
                )}
                {l.reason && <p className="text-xs text-slate-500 mt-1 italic">Reason: {l.reason}</p>}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
